import { IMaskInput } from 'react-imask';
import React, { forwardRef, RefCallback } from 'react';
import { InputMaskElement } from 'imask/controls/input';

type Props = {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
};

const numOptions = { mask: Number, min: 0, max: 10000000000000, thousandsSeparator: '.', radix: ',', mapToRadix: [','], normalizeZeros: false, lazy: false };

const AmountInputField = forwardRef<InputMaskElement, Props>(
  (props, inputRef) => {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        id="amountInput"
        placeholder="1.000.000,00"
        inputRef={inputRef as RefCallback<InputMaskElement>}
        mask="num"
        blocks={{ num: numOptions }}
        unmask={false}
        onAccept={(value) => {
          if (typeof value === 'string') {
            onChange({
              target: { name: other.name, value: value.replace(/\s+/g, '') },
            });
          }
        }}
      />
    );
  },
);

export default AmountInputField;
